import React, { useEffect, useState } from "react";
import Select from "react-select";
import DataTable from "react-data-table-component";
import { useAuth } from "../../../context/auth-context";
import { rootUrl } from "../../../helpers";
import { toast } from "react-toastify";
import { useOutletContext } from "react-router-dom";
import axios from "axios";
import { FaPlus, FaTimes } from "react-icons/fa";

const Journal = ({ client }) => {
  const [journalData, setJournalData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    fromcoa: "",
    tocoa: "",
    amount: "",
    desc: "",
  });

  const auth = useAuth();

  const allData = useOutletContext();

  const fetchJournalData = async () => {
    try {
      const response = await axios.get(rootUrl(`/getJournal/${auth.user.id}`));
      setJournalData(response.data.data);
      console.log(response.data)
    } catch (error) {
      console.error("Error fetching journal data:", error);
    }
  };
  
  useEffect(() => {
    fetchJournalData();
  }, []);
  
  const handleFormSubmit = async () => {
    try {
      const updatedFormData = { ...formData, uid: auth.user.id };
  
      const response = await axios.post(rootUrl(`/addJournal`), updatedFormData, {
        headers: { "Content-Type": "application/json" },
      });
  
      if (response.data.status === 200) {
        toast.success("Sucessful")
        setShowForm(false);
        fetchJournalData(); 
      } else {
        toast.error("Something went wrong")
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  }

  const columns = [
    {
      name: "Sn",
      selector: (_, index) => index + 1,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => row.date.substring(0, 10),
      sortable: true,
    },
    {
      name: "From",
      selector: (row) =>
        allData.budget?.find((a) => a.id === row.from_coa)?.coa 
        +": "+
        allData.coa?.find(b=>b.account === allData.budget?.find((a) => a.id === row.from_coa)?.coa)?.name || "N/A",
    },
    {
      name: "To",
      selector: (row) =>
        allData.budget?.find((a) => a.id === row.to_coa)?.coa 
        +": "+
        allData.coa?.find(b=>b.account === allData.budget?.find((a) => a.id === row.to_coa)?.coa)?.name || "N/A",
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => row.description,
    },
  ];

  return (
    <div className="w-full bg-white min-h-[400px] rounded-md mt-10 p-5">
      <div className="flex justify-between">
        <div className="flex flex-col">
          <h1 className="text-[25px] text-slate-800 font-bold">Journal</h1>
        </div>
        <button
          onClick={() => setShowForm(!showForm)}
          className="flex btn bg-blue-900 text-white items-center justify-center border border-gray-300 h-[40px] px-3 ml-2 rounded-md text-[12px]"
        >
          <FaPlus/>
          Add
        </button>
      </div>
      <hr />

      <DataTable
        columns={columns}
        data={journalData}
        pagination
        responsive
        highlightOnHover
      />

      {showForm && (
        <div
          className="bg-white fixed top-0 right-0 h-full w-1/4 overflow-hidden shadow-lg"
          style={{ display: showForm ? "block" : "none" }}
        >
          <FaTimes
            onClick={() => setShowForm(false)}
            className="text-lg text-red-500 float-right m-2" />
          <h3 className="m-2 font-semibold text-lg">Journal</h3>
          <hr />
          <div className="max-w-md mx-auto bg-white p-8 rounded">
            <Select
              id="budget"
              options={allData.budget.map((res) => ({
                value: res.id,
                label: `${res.coa}: ${allData.coa?.find(a=>a.account === res.coa)?.name}`,
              }))}
              placeholder="From COA"
              onChange={(selected) =>
                setFormData({ ...formData, fromcoa: selected.value })
              }
              className="border rounded p-2 w-full mb-4"
            />
            <Select
              id="coa"
              options={allData.budget.map((res) => ({
                value: res.id,
                label: `${res.coa}: ${allData.coa?.find(a=>a.account === res.coa)?.name}`,
              }))}
              placeholder="To COA"
              onChange={(selected) =>
                setFormData({ ...formData, tocoa: selected.value })
              }
              className="border rounded p-2 w-full mb-4"
            />
            <input
              id="amount"
              type="text"
              placeholder="Amount"
              className="border rounded p-2 w-full mb-4"
              value={formData.amount}
              onChange={(e) =>
                setFormData({ ...formData, amount: e.target.value })
              }
            />
            <textarea
              id="desc"
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:border-blue-500"
              placeholder="Description"
              value={formData.desc}
              onChange={(e) =>
                setFormData({ ...formData, desc: e.target.value })
              }
            />
            <div className="text-center">
              <button
                onClick={handleFormSubmit}
                className="mt-6 bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600 focus:outline-none focus:shadow-outline-blue active:bg-blue-800"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Journal;
